(() => {
  const config = document.getElementById('cr-format');
  const labels = config ? config.dataset : {};
  const format = () => {
    document.querySelectorAll('a[href]').forEach(a=>{
      let url;try{url=new URL(a.getAttribute('href'),location.href)}catch{return}
      const host=url.hostname.replace(/^www\./,'').toLowerCase();
      const path=url.pathname.replace(/\/+$/,'').toLowerCase();
      let destination='';
      if(host==='rof.maharashtra.gov.in')destination='https://rof.mahaonline.gov.in/';
      else if(host==='chennaicorporation.gov.in'&&!path)destination='https://chennaicorporation.gov.in/gcc/';
      else if(host==='tmrsearch.ipindia.gov.in'&&path==='/esearch')destination='https://tmrsearch.ipindia.gov.in/tmrpublicsearch/';
      else if(host==='pt.kar.nic.in'&&!path)destination='https://ptax.karnataka.gov.in/';
      else if(host==='wbprofessiontax.gov.in'&&!path)destination='https://professiontax.wb.gov.in/';
      else if(host==='indiacode.nic.in'&&path==='/show-data'&&url.searchParams.get('sectionId')==='1041'&&url.searchParams.get('sectionno')==='7'&&url.searchParams.get('actid')==='AC_CEN_22_29_00007_200906_1517807325904')destination='https://www.incometaxindia.gov.in/w/section-7-196';
      if(!destination)return;
      const oldUrl=a.getAttribute('href');
      a.setAttribute('href',destination);
      const w=document.createTreeWalker(a,NodeFilter.SHOW_TEXT);
      while(w.nextNode()){
        let text=w.currentNode.textContent;
        if(text.trim()===oldUrl||text.trim()===oldUrl.replace(/\/$/,''))text=text.replace(text.trim(),destination.replace(/\/$/,''));
        else if(text.trim()===url.hostname)text=text.replace(text.trim(),new URL(destination).hostname);
        else if(host==='rof.maharashtra.gov.in')text=text.replace(/rof\.maharashtra\.gov\.in/gi,'rof.mahaonline.gov.in');
        w.currentNode.textContent=text;
      }
    });
    document.querySelectorAll('.cr-trend-post .cr-inshort p,.cr-trend-post .cr-prose p').forEach(p=>{
      const w=document.createTreeWalker(p,NodeFilter.SHOW_TEXT);while(w.nextNode())w.currentNode.textContent=w.currentNode.textContent.replace(/,\s*calendar.year(?=\s|,|\.)/gi,'');
    });
    document.querySelectorAll('.cr-prose h1,.cr-prose h2,.cr-prose h3,.cr-prose h4').forEach(h=>{
      if(!/calendar.year/i.test(h.textContent)||!/registration|compan|LLP|trend|reports/i.test(h.textContent))return;
      const level=Number(h.tagName.slice(1));let n=h.nextElementSibling;
      while(n&&!(/^H[1-6]$/.test(n.tagName)&&Number(n.tagName.slice(1))<=level)){const next=n.nextElementSibling;n.remove();n=next}h.remove();
    });
    document.querySelectorAll('a').forEach(a=>{
      if(/calendar-year/.test(a.getAttribute('href')||'')||/calendar.year/i.test(a.textContent)&&/registration|trend|reports/i.test(a.textContent)){
        const card=a.closest('.cr-post-card,.cr-card');if(card)card.remove();else if(a.parentElement.tagName==='LI')a.parentElement.remove();else a.remove();
      }
    });
    document.querySelectorAll('.cr-prose p').forEach(p => {
      if (!p.textContent.replace(/[\s\u00a0\u200b]/g, '') && !p.querySelector('img,svg,iframe,video,input')) p.classList.add('cr-blank');
    });
    document.querySelectorAll('.cr-prose table,.cr-trend-table').forEach(table => {
      if (table.dataset.crFormatted) return;
      table.dataset.crFormatted = 'true';
      const first = table.tHead?.rows[0] || table.rows[0];
      if (!first || !first.querySelector('th')) return;
      const headers = Array.from(first.cells).map(cell => {
        const copy = cell.cloneNode(true);
        copy.querySelectorAll('br').forEach(br => br.replaceWith(' '));
        return copy.textContent.trim().replace(/\s+/g, ' ');
      });
      const numeric = table.classList.contains('cr-trend-table') || headers.some(h => /^(Private(?: Limited(?: Companies?)?)?|OPC|LLP|Registrations|Share|Total|YoY)$/i.test(h));
      if (numeric) table.classList.add('cr-table-numeric');
      if (headers.length >= 3 && !table.querySelector('tbody [rowspan], tbody [colspan]')) {
        table.classList.add('cr-table-cards');
        if (!numeric) table.classList.add('cr-table-text');
        table.setAttribute('role', 'table');
        first.classList.add('cr-table-header');
        first.setAttribute('role', 'row');
        Array.from(first.cells).forEach(cell => cell.setAttribute('role', 'columnheader'));
      }
      Array.from(table.tBodies).forEach(body => {
        body.setAttribute('role', 'rowgroup');
        Array.from(body.rows).forEach(row => {
          if (row === first) return;
          row.setAttribute('role', 'row');
          let col = 0;
          Array.from(row.cells).forEach((cell, index) => {
            const label = headers[col];
            col += cell.colSpan;
            if (index > 0 && label) cell.dataset.label = label;
            cell.setAttribute('role', index === 0 ? 'rowheader' : 'cell');
            if (numeric && index > 0 && cell.colSpan === 1 && !cell.querySelector('small')) {
              const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
              const nodes = [];
              while (walker.nextNode()) nodes.push(walker.currentNode);
              nodes.forEach(node => {
                const match = node.textContent.match(/^(\s*[\d,]+)\s+(\([<>+−\-\d.]+%\))\s*$/);
                if (!match) return;
                const pct = document.createElement('span');
                pct.className = 'cr-table-pct';
                pct.textContent = match[2];
                node.textContent = match[1];
                node.after(pct);
              });
            }
          });
          const period = row.cells[0]?.textContent.trim() || '';
          const isFY = /Financial Year/i.test(headers[0]);
          const isCY = /Calendar Year/i.test(headers[0]);
          let note = '';
          if (isFY && /^2026[-–]27/.test(period)) note = labels.fyYtd;
          else if (isFY && /^2021[-–]22/.test(period)) note = labels.fyIncomplete;
          else if (isCY && /^2026/.test(period)) note = labels.cyYtd;
          else if (isCY && /^202[12]/.test(period)) note = labels.incomplete;
          if (note && !row.querySelector('.cr-period-note')) {
            row.classList.add('cr-partial-row');
            const badge = document.createElement('span');
            badge.className = 'cr-period-note';
            badge.textContent = note;
            row.cells[0].appendChild(badge);
          }
        });
      });
      const parent = table.parentElement;
      if (parent && (parent.style.overflow || parent.style.overflowX || parent.classList.contains('rsw-table-wrap'))) parent.classList.add('cr-table-wrapper');
    });
    document.querySelectorAll('.cr-trend-post .cr-prose p').forEach(p => {
      if (/is year.to.date|are incomplete|is incomplete|covers January.Sep|covers April.Sep/i.test(p.textContent)) p.classList.add('cr-data-alert');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', format, { once: true });
  else format();
  document.addEventListener('shopify:section:load', format);
})();

(function(){
const decorative=/[\u{1F300}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}\u2605\u2606\u2726\u2728\u2705\u2714\u2713\u27A1\u2192\u2190\uFE0F\u200D]/gu;
/* Defined legal terms written with capital initials (31 Oct 2026): Share Certificate, Annual Return, etc. Small words (of, and) stay lower case; LLP stays upper case. */
const termCase=m=>m.split(/(\s+)/).map(w=>/^\s+$/.test(w)?w:/^(of|and)$/i.test(w)?w.toLowerCase():/^llp$/i.test(w)?'LLP':w.charAt(0).toUpperCase()+w.slice(1).toLowerCase()).join('');
const terms=/\b(?:share certificates?|annual returns?|annual general meetings?|extraordinary general meetings?|board meetings?|board resolutions?|special resolutions?|ordinary resolutions?|financial statements?|registered office|certificate of incorporation|memorandum of association|articles of association|authorised capital|authorized capital|paid-up capital|share capital|statutory audit|statutory auditors?|first auditors?|llp agreement|register of members|commencement of business|digital signature certificates?|director identification numbers?|annual compliance)\b/gi;
function cleanText(text){
if(text.trim()==='—')return 'Not available';
if(text.trim()==='→')return 'Next';
if(text.trim()==='←')return 'Previous';
return text.replace(/\s*—\s*/g,' ').replace(decorative,'').replace(/ {2,}/g,' ').replace(/\bcompliance calendar\b/gi,'Compliance Calendar').replace(/\bdesignated(\s+)partner(s?)\b/gi,(_,space,plural)=>'Designated'+space+'Partner'+plural.toLowerCase()).replace(/\btotal registrations?\b/gi,phrase=>phrase.toLowerCase().endsWith('s')?'Total Registrations':'Total Registration').replace(terms,termCase).replace(/\b(?:sharerholders?|shareholders?|companies|company|startups?|directors?|partners?|founders?|businesses|business|registrations?|compliance|certificates?|entrepreneurs?)\b/gi,word=>{
const normalized=word.toLowerCase().replace('sharerholder','shareholder');
return normalized.charAt(0).toUpperCase()+normalized.slice(1);
});
}
function clean(root){
if(!root)return;
if(root.nodeType===3){const p=root.parentElement;if(!p||p.closest('script,style,code,pre,svg,textarea,input'))return;let t=cleanText(root.nodeValue);if(t!==root.nodeValue)root.nodeValue=t;return}
if(root.nodeType!==1)return;
if(root.matches('script,style,code,pre,svg,textarea,input'))return;
const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let n;const nodes=[];while(n=walker.nextNode())nodes.push(n);nodes.forEach(clean);
}
function boot(){
clean(document.body);document.title=cleanText(document.title);
new MutationObserver(records=>{records.forEach(r=>{if(r.type==='characterData')clean(r.target);else r.addedNodes.forEach(clean)})}).observe(document.body,{childList:true,subtree:true,characterData:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

document.addEventListener('click',function(e){
const link=e.target.closest('.cr-trend-topnav a');if(!link)return;
const url=new URL(link.href,location.href);if(url.pathname!==location.pathname||!url.hash)return;
const target=document.getElementById(url.hash.slice(1));if(!target)return;
e.preventDefault();history.replaceState(null,'',url.hash);target.scrollIntoView({behavior:'auto',block:'start'});
});
